import { configureStore } from "@reduxjs/toolkit";
import inquiryReducer from "@store/inquiry/inquirySlice";
import eventFormReducer from "@store/eventForm/eventFormSlice";
import memberInfoReducer from "@store/member/memberInfoSlice";
import memberPointReducer from "@store/member/memberPointSlice";
import memberMyProductReducer from "@store/member/memberMyProductSlice";
import memberMyRedemptionReducer from "@store/member/memberMyRedemptionSlice";
import memberAuthReducer from "@store/member/memberAuthSlice";
import formStepReducer from "@store/ui/formStepSlice";
import redeemGiftDetailReducer from "@store/redeem/redeemSlice";

export const store = configureStore({
  reducer: {
    inquiry: inquiryReducer,
    eventForm: eventFormReducer,
    memberAuth: memberAuthReducer,
    memberInfo: memberInfoReducer,
    memberPoint: memberPointReducer,
    memberMyProduct: memberMyProductReducer,
    memberMyRedemption: memberMyRedemptionReducer,
    formStep: formStepReducer,
    redeemGiftDetail:redeemGiftDetailReducer,
  },
});
